/**
 * update node
 * 0.9.12.2 / Prototype
 * 0.9.13.1 / 실패처리
 * 0.9.15.1 / IE11
 * 0.9.15.2 / 입고예정일 표기
 */

import {MakeshopInfo} from "./MakeshopInfo";
import {StockView} from "./StockView";
import {StockViewMobile} from "./StockViewMobile";
import {SellpiaInfo} from "./SellpiaInfo";
import {SellpiaInfoDebug} from "./SellpiaInfoDebug";

export class MakeshopStock {
    static version = "0.12.1.3";
    constructor(makeshop_info, config) {
        this.config = config;
        this.makeshop_info = new MakeshopInfo(makeshop_info);
        this.sellpia_info = new SellpiaInfo(this.makeshop_info.getAdminuser(), this.makeshop_info.getBrandUid());
        this._init_();
    }

    _init_ () {
        if (!this.makeshop_info.getOptionsInfo()) {
            throw new Error("옵션 정보가 누락되었거나. 가상테그가 잘 못 적용 되었습니다. ( <!--/json/option_info/--> )");
        }

        this.sellpia_info.loader().then(()=>{
            Array.from(document.getElementsByClassName(this.config.stock_view_btn_id)).map((dom)=> {
                dom.style.display = "";
            });
            this.config?.loadingCallback();
        }).catch(()=>{
            if (!this.config?.stock_view_btn_display_allway) { // 버튼 항상 사용이 켜 있지 않으면.. 버튼은 무조건 숨김
                Array.from(document.getElementsByClassName(this.config.stock_view_btn_id)).map((dom) => {
                    dom.style.display = "hidden";
                })
            } else {
                Array.from(document.getElementsByClassName(this.config.stock_view_btn_id)).map((dom)=> {
                    dom.style.display = "";
                });
            }
        })

        if (this.makeshop_info.getShopInfo()?.is_mobile) {
            this.stock_view = new StockViewMobile();
        } else {
            this.stock_view = new StockView();
        }
    }

    getMakeshopOptionInfo() {
        return this.makeshop_info.getOptionsInfo()
    }
    getSellpiaOptionInfo() {
        return this.sellpia_info.getOptionInfo()
    }
    getSellpiaLastUpdateDate() {
        return this.sellpia_info.getLastUpdate()
    }

    getMakeshopOptionCategory() {
        return this.makeshop_info.getCategoryInfo();
    }
    /**
     * 레이어를 오픈 합니다.
     */
    openLayout() {
        if (this.sellpia_info) {
            let sellpia_info = this.getSellpiaOptionInfo();
            let options = MakeshopStock.makeViewOptionData(this.getMakeshopOptionCategory(), this.getMakeshopOptionInfo(), this.getSellpiaOptionInfo());
            let option_info = sellpia_info[Object.keys(sellpia_info).find(itme => true)]; // is first option
            this.stock_view.openLayout({
                options : options,
                last_update : this.getSellpiaLastUpdateDate(),
                makeshop_product : this.makeshop_info.getProductInfo()
            });
        }
    }

    // openMinLayout() {
    //     if (!this.sellpia_options.view_min) return;
    //     if (this.sellpia_info) {
    //         let sellpia_info = this.sellpia_info;
    //         let makeshop_info = MakeshopProduct.loadMakeshopInfo();
    //         let options = MakeshopStock.optionsLeader(makeshop_info.options, sellpia_info);
    //         let option_info = sellpia_info[Object.keys(sellpia_info).find(itme => true)]; // is first option
    //         this.stock_view_min.openLayout(options, option_info);
    //     }
    // }

    // loader() {
    //     SellpiaInfo.loadSellpiaProduct(this.makeshop_info.getBrandUid(), this.makeshop_info.getAdminuser())
    //         .then((sellpia_info) => {
    //             this.sellpia_info = sellpia_info;
    //             return SellpiaInfo.loadSellpiaInfo(this.makeshop_info.getAdminuser())
    //         }).then((sellpia_info)=>{
    //             Array.from(document.getElementsByClassName("makeshop-stock-sellpia-btn")).map((dom)=>{
    //                 dom.style.display = "";
    //             })
    //         }).catch(e => {
    //             Array.from(document.getElementsByClassName("makeshop-stock-sellpia-btn")).map((dom)=>{
    //                 dom.style.display = "hidden";
    //             })
    //             this.sellpia_info = {};
    //         });
    // }

    static findRow(options, option_index, option_title, category_index) {
        if (options[option_index+1]?.[category_index] != option_title) {    // 마지막 노드
            if (options[option_index-1]?.[category_index] == option_title) {    // 첫번째 노트가 아님 (이전 옵션이 같음)
                return options.filter(option=>option?.[category_index] == option_title).length;
            } else {
                return 1; // 마지막, 첫번째는 row 가 1
            }
        }
        return -1;
    }

    static matchSellpiaOption(makeshop_option, sellpia_options) {
        let find_key = Object.keys(sellpia_options).find(key=>{
            return (sellpia_options[key].option_title == makeshop_option.title.join(','));
        });
        return find_key ? sellpia_options[find_key] : false;
    }

    static makeViewOptionData(category_info, makeshop_options_info, sellpia_info) {
        // TODO 경우에 따라서는 여기에서 sort 가 필요.
        return makeshop_options_info.map((option, option_index)=>{
            let sellpia_option = this.matchSellpiaOption(option, sellpia_info);
            return {
                title: ((option, option_index, makeshop_options_info) => {
                    let titles = option.title.filter(title=>title!=null);
                    return titles.map((title, index)=>{
                        return {title:title, row:this.findRow(makeshop_options_info, option_index, title, index)}
                    }).filter(item=>item.title != null)
                })(option, option_index, makeshop_options_info),
                stock_key: (() => {
                    return null;
                })(),
                option_uid: sellpia_option?.makeshop_ocode || "",
                option_title: sellpia_option?.option_title || "",
                status: sellpia_option?.status || (option.is_soldout ? "품절" : "구매가능"),
                status_class:  sellpia_option?.status_class,
                stock_in_due_date:  sellpia_option?.stock_in_due_date,
                pos:  sellpia_option?.pos,
                pos_sell: ((pos) => {
                    if (typeof (pos) !== "object") return null;
                    return Object.keys(pos).find(key => {
                        return pos[key].stock_avail === "구입가능";
                    }) ? true : false;
                })( sellpia_option?.pos)
            }
        });
    }

    makeshopOptionsTextUpdateCallBack(option) {
        let _this = window?.__MakeshopStock;
        return _this?.makeshopOptionsTextUpdate.call(_this, option);
    }

    makeshopOptionsTextUpdate({option_mode, current_idx:idx}) {
        if (this.config?.display_option_text_use !== true) { return; } // 옵션 텍스트 변경 기능 사용 하지 않음
        let options = document.querySelectorAll('[name="optionlist[]"].' + option_mode + '_option');
        if (options?.length === idx + 2) { // 마지막 노드 변경시 텍스트 추가
            let select = getSelectedOption(options, idx);
            Array.from(options[options.length - 1]?.children)
                .filter(item=>item.title) // 옵션 선택 필드 제거
                .map(option=>{
                    let match_option_string = [...select, option.title].join(',');
                    let sellpia_options = window.__MakeshopStock.getSellpiaOptionInfo();
                    let sellpia_options_key = Object.keys(sellpia_options);
                    let find_sellpia_options_key = sellpia_options_key.find(key=>sellpia_options[key].option_title == match_option_string );
                    if (find_sellpia_options_key) {
                        if (this.config.display_option_text.flag.findIndex(flag => sellpia_options[find_sellpia_options_key]?.status_flag === flag)) {
                            option.innerText += this.config.display_option_text.glue + sellpia_options[find_sellpia_options_key].status;
                        }
                    }
                })
        }
        function getSelectedOption(options, idx) {
            return Array.from(options).map(option=>{
                return option?.children[option?.selectedIndex||0]?.getAttribute('title') || false
            }).filter(i=>i)
        }
    }
}
